import React, {useState} from 'react';
import './styles.css'

const Bascet= function(props){
    return(
      <div title="удалить граф" className='center' >
        <svg className='logoArrow' width="40px" height="40px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 11V17"  strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14 11V17"  strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M4 7H20"  strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z"  strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z"  strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
    )
}
export default Bascet;


